class ProductOffer extends HTMLElement {
  constructor() {
    super();
    this.quantity = this.getAttribute('data-quantity');
    this.ctaButtons = this.querySelectorAll('[data-action="add-to-offer"]');
    this.productsCount = this.querySelector('[data-products-count]');
    this.productsList = this.querySelector('[data-selected-products-list]');
    this.productsListContainer = this.querySelector('[data-selected-products-list] [name="selected-products"]');
    this.emptyMessage = this.querySelector('.product-offer-section__empty-message');
    this.freeMessage = this.querySelector('.product-offer-section__free-text');
    this.addBundleToCartButtonWrapper = this.querySelector('.product-offer-section__add-to-cart');
    this.addBundleToCartButton = this.querySelector('#add-offer-to-cart-button');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  connectedCallback() {
    this.ctaButtons.forEach(button => {
      button.addEventListener('click', this.addToOffer.bind(this));
    });

    this.addBundleToCartButton.addEventListener('click', this.addBundleToCart.bind(this));
  }

  addToOffer(event) {
    event.preventDefault();

    const productId = event.target.getAttribute('data-product-id');

    const productElement = this.querySelector(`.product-offer-section__products .offer-product__wrapper[data-product-id="${productId}"]`);
    if (productElement) {
      const clonedElement = productElement.cloneNode(true);

      const button = clonedElement.querySelector('[data-action="add-to-offer"]');
      if (button) button.remove();

      const removeButton = document.createElement('button');
      removeButton.innerHTML = '<svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M4.35714 0.5C4.11365 0.5 3.89105 0.633751 3.78215 0.845492L3.31698 1.75H1.14286C0.787817 1.75 0.5 2.02982 0.5 2.375C0.5 2.72018 0.787817 3 1.14286 3L1.14286 9.25C1.14286 9.94036 1.71849 10.5 2.42857 10.5H7.57143C8.28151 10.5 8.85714 9.94036 8.85714 9.25V3C9.21218 3 9.5 2.72018 9.5 2.375C9.5 2.02982 9.21218 1.75 8.85714 1.75H6.68302L6.21785 0.845492C6.10895 0.633751 5.88635 0.5 5.64286 0.5H4.35714ZM3.07143 4.25C3.07143 3.90482 3.35925 3.625 3.71429 3.625C4.06933 3.625 4.35714 3.90482 4.35714 4.25V8C4.35714 8.34518 4.06933 8.625 3.71429 8.625C3.35925 8.625 3.07143 8.34518 3.07143 8V4.25ZM6.28571 3.625C5.93067 3.625 5.64286 3.90482 5.64286 4.25V8C5.64286 8.34518 5.93067 8.625 6.28571 8.625C6.64075 8.625 6.92857 8.34518 6.92857 8V4.25C6.92857 3.90482 6.64075 3.625 6.28571 3.625Z"></path></svg> Remove';
      removeButton.className = 'offer-product__remove-button';

      removeButton.addEventListener('click', () => {
        clonedElement.remove();

        const activeProducts = this.querySelectorAll('[data-selected-products-list] .offer-product__wrapper');
        if (activeProducts.length === 0) {
          this.productsList.classList.add('hidden');
        }

        if (activeProducts.length < this.quantity) {
          this.emptyMessage.classList.remove('hidden');
          this.addBundleToCartButtonWrapper.classList.add('hidden');
        }

        this.productsCount.textContent = activeProducts?.length || 0;
        this.freeMessage.classList.toggle('hidden', activeProducts.length != 3);

        this.updatePrice();
      });

      clonedElement.querySelector('.offer-product__details').appendChild(removeButton);
      this.productsListContainer.appendChild(clonedElement);
    }

    const activeProducts = this.querySelectorAll('[data-selected-products-list] .offer-product__wrapper');
    if (activeProducts.length >= 0) {
      this.productsList.classList.remove('hidden');
    }

    if (activeProducts.length >= this.quantity) {
      this.emptyMessage.classList.add('hidden');
      this.addBundleToCartButtonWrapper.classList.remove('hidden');
    } else {
      this.addBundleToCartButtonWrapper.classList.add('hidden');
    }

    this.productsCount.textContent = activeProducts?.length || 0;
    this.freeMessage.classList.toggle('hidden', activeProducts.length != 3);

    this.updatePrice();
  }

  updatePrice() {
    this.querySelectorAll('[data-selected-products-list] .offer-product__wrapper').forEach((product, index) => {
      const priceEl = product.querySelector('.offer-product__price');

      if (index == 3) {
        if (!priceEl.classList.contains('price--zero')) {
          const zeroPriceSpan = document.createElement('span');
          zeroPriceSpan.classList.add('offer-product__price--zero');
          zeroPriceSpan.textContent = '> $0';

          priceEl.classList.add('price--zero');
          priceEl.appendChild(zeroPriceSpan);
        }
      } else if (priceEl.classList.contains('price--zero')) {
        priceEl.classList.remove('price--zero');
        priceEl.querySelector('.offer-product__price--zero').remove();
      }
    });
  }

  addBundleToCart(event) {
    this.addBundleToCartButton.style.opacity = '0.6';
    this.addBundleToCartButton.style.pointerEvents = 'none';
    event.preventDefault();
    const activeProducts = this.querySelectorAll('[data-selected-products-list] .offer-product__wrapper');
    const variantIds = Array.from(activeProducts).map(product => {
      return product.getAttribute('data-product-id');
    });

    if (variantIds.length > 0) {
      const formData = {
        items: variantIds.map(id => ({ id: id, quantity: 1 })),
        sections: this.cart
          .getSectionsToRender()
          .map((section) => section.section),
        sections_url: window.location.pathname,
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => response.json())
        .then(data => {
          this.cart?.renderContents(data);
        })
        .catch(error => {
          console.error('Error adding bundle to cart:', error);
        })
        .finally(() => {
          this.addBundleToCartButton.style.opacity = '';
          this.addBundleToCartButton.style.pointerEvents = '';
        });
    }
  }
}

// Define the custom element
customElements.define('product-offer', ProductOffer);